"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SHu_const_googleDrive = void 0;
exports.SHu_const_googleDrive = {
    baseUrl: "https://drive.google.com/drive/folders/",
    objectIds: {
        masterDrive: "0ADg0eM3OMuqPUk9PVA",
        properties: "1QAsVJW6l9PgZvnl64FiO0LRKmLy8xdEv",
        states: { uncategorized: "1rUyCeO-Es4PvB1f7QEJpBOxqcnTOR3u7" },
    },
};
